"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Book a visit",
  description: "Pick a time that suits you and tell us about the job."
}, {
  number: "02",
  title: "Assessment & quote",
  description: "We inspect the space on site and give you a clear plan and price."
}, {
  number: "03",
  title: "We build",
  description: "Our crew gets to work with careful prep, clean tools, and steady progress."
}, {
  number: "04",
  title: "Final walkthrough",
  description: "We review the finished work together so you are satisfied before we leave."
}];
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.05
  });
  return <section id="how-it-works" className="bg-card text-card-foreground border-b border-border py-14 md:py-20 lg:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mb-10 md:mb-14 text-left">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-normal leading-[1.15] tracking-tight mb-3 text-foreground">
            How it works
          </h2>
          <p className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed">
            A straightforward process from initial site visit to finished project.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12 transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0 motion-reduce:opacity-100"}`}>
          {steps.map((step, i) => <div key={step.number} data-index={i} className="pt-4 border-t border-border flex flex-col justify-start">
              <span className="font-serif font-normal text-2xl text-primary mb-3">
                {step.number}
              </span>
              <h3 className="text-lg font-serif font-normal mb-2 text-foreground">
                {step.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                {step.description}
              </p>
            </div>)}
        </div>

        <div className="text-left">
          <Button size="lg" variant="default" className="min-h-[44px] px-8 text-base font-medium rounded-xs shadow-none" asChild>
            <Link to="/BookAppointmentPage">Book Appointment</Link>
          </Button>
        </div>
      </div>
    </section>;
}